module.exports = __webpack_public_path__ + "img/bjtu.1317a0ed.png";